import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-paragraph',
  templateUrl: './paragraph.component.html',
  styleUrls: ['./paragraph.component.scss'],
})
/**
 * Paragraph atom
 */
export class ParagraphComponent {
  private _bold: boolean = false;

  /**
   * Whether the font-weight is bold or not
   */
  @Input()
  get bold(): boolean {
    return this._bold;
  }

  /**
   * Sets the font-weight as bold
   * @param {any} value value might be any type and it is coerced into a boolean
   */
  set bold(value: any) {
    this._bold = coerceBooleanProperty(value);
  }
}
